<template>
	<ul class="list">
		<li v-for="item in list" @click="toDetail(item)">
			<div class="list-r">
				<div class="list-title">
					<span class="list-btn">{{item.typeName}}</span>
					<h3>{{item.title}}</h3>
				</div>
				<div class="list-tips">
					<!-- <span class="list-from">作者：{{item.author}}</span> -->
					<span>发表于{{item.addTimeStr}}</span>
				</div>
				<div class="list-txt">
					{{item.introduction}}
				</div>
			</div>
		</li>
	</ul>
</template>

<script>
	export default {
		name: 'SearchAll',
		props: {
			list: {
				type: Array,
				value: []
			}
		},
		methods: {
			toDetail(item){
				this.$emit('toDetail', {
					linkRoute: item.linkRoute,
					linkCode: item.linkCode
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.list{
		padding: 10px;
		li{
			display: flex;
			border-top: 1px solid #e5e6e9;
			padding: 18px 24px;
			.list-img{
				width: 176px;
				height: 111px;
				margin-right: 24px;
				border-radius: 4px;
				img {
					width: 176px;
					height: 111px;
				}
			}
			.list-r{
				flex:1;
				.list-title{
					position: relative;
					display: flex;
					span.list-btn{
						display: inline-block;
						padding: 1px 8px;
						margin-right: 7px;
						font-size: 12px;
						border-radius: 3px;
						background-color: #fff;
						border: 1px solid #1075e7;
						color: #1075e7;
						user-select: none;
						cursor: pointer;
						text-align: center;
						line-height: 18px;
						position: absolute;
						left: 0;
						top: 2px;
					}
					h3{
						padding-left: 50px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						word-wrap: normal;
						font-size: 18px;
						font-weight: 650;
						line-height: 26px
					}
				}
				.list-tips{
					display: flex;
					align-items: center;
					line-height: 18px;
					margin-top: 9px;
					margin-bottom: 11px;
					font-size: 12px;
					color: #8d8d8e;
					letter-spacing: .86px;
					.list-from{
						display: inline-block;
						color: #333;
						margin-right: 14px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						word-wrap: normal;
						max-width: 170px;
					}
				}
				.list-txt{
					font-size: 12px;
					color: #404040;
					text-align: justify;
					line-height: 18px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 3;
					overflow: hidden;
				}
			}
		}
		li:first-of-type{
			border-top: none;
		}
		li:hover{
			position: relative;
			box-shadow:0 2px 8px 0 rgba(34,123,255,.36);
			z-index: 1
		}
	}
</style>
